import React from "react";

import FunnelDashboardSecundaryTable from "./Variations/SecundaryTable";
import FunnelDashboardBasicTable from "./Variations/BasicTable";

import "./style.scss";

const FunnelDashboardTable = ({ variation, data, headerValues, handleDelete, layoutData}) => {
  if (variation === "secundary")
    return <FunnelDashboardSecundaryTable data={data} headerValues={headerValues} layoutData={layoutData} handleDelete={handleDelete} />;
  else
    return <FunnelDashboardBasicTable data={data} headerValues={headerValues} layoutData={layoutData} handleDelete={handleDelete} />;
};

export default FunnelDashboardTable;